import React, { useRef, useState, useEffect } from "react";

const UpdateNextOfNext = ({ onSubmit, onCancel, current }) => {
    // local state
    const data = ["Brother", "Father", "Mother", "Sister", "Uncle", "Other", "Relative"];
    const [relationship, setRelationship] = useState();
    // ref
    const name = useRef(null);
    const mobileRef = useRef(null);
    const addressRef = useRef(null);
    useEffect(() => {
        name.current.value = current.name;
        mobileRef.current.value = current.mobile;
        addressRef.current.value = current.address;
        setRelationship(current.relationship);
    }, [current.name, current.mobile, current.address, current.relationship]);

    return (
        <>
            <div className="col-4 bg-primary pl-5">
                <h5>Update Next of Kin</h5>
            </div>

            <form
                method="POST"
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit({
                        name: name.current.value,
                        relationship,
                        address: addressRef.current.value,
                        mobile: mobileRef.current.value,
                    });
                    name.current.value = "";
                    addressRef.current.value = "";
                    mobileRef.current.value = "";
                    name.current.focus();
                }}
            >
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Name</strong>
                            </td>
                            <td>
                                <input type="text" className="form-control input-height" id="name-id" required ref={name} aria-describedby="name-id" placeholder="enter name" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Mobile</strong>
                            </td>
                            <td>
                                <input type="text" className="form-control input-height" id="mobile-id" required ref={mobileRef} aria-describedby="mobile-id" placeholder="enter mobile" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Relationship to Staff</strong>
                            </td>
                            <td>
                                <select
                                    onChange={(e) => {
                                        setRelationship(e.target.value);
                                    }}
                                    className="form-control input-height"
                                    required
                                >
                                    <option value="">Select...</option>
                                    {data.map((item) => (
                                        <option selected={item === current.relationship} key={item} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Contact Address</strong>
                            </td>
                            <td>
                                <textarea
                                    name="address-id"
                                    id="address-id"
                                    ref={addressRef}
                                    className="form-control form-control-textarea"
                                    required
                                    rows="4"
                                    placeholder="enter contact address"
                                ></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="text-center">
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                        Update Change <i className="material-icons">arrow_right_alt</i>
                    </button>
                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                        <i className="material-icons text-danger">cancel</i> Cancel
                    </button>
                </div>
            </form>
        </>
    );
};

export default UpdateNextOfNext;
